import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=6f789d32&scoped=true"
import script from "./CommonForm.vue?vue&type=script&lang=js"
export * from "./CommonForm.vue?vue&type=script&lang=js"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=6f789d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f789d32",
  null
  
)

export default component.exports